<template>
 <v-container>
    <!-- <div> Component 시험 페이지</div>
    <div class="chart_Layout">
      <Bar
        :chart-options="options"
        :chart-data="chartData"
        :height="200"
      />
    </div> -->

    <div class="container_2">
        <div class="box1">1</div>
        <div class="box2">2</div>
        <div class="box3">3</div>
        <div class="box4">4</div>
        <div class="box5">5</div>
    </div>


 </v-container>
</template>

<script>
  // import Apis from '@/api/apis'

  // import { Bar }  from 'vue-chartjs/legacy'
  import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
  import zoomPlugin from 'chartjs-plugin-zoom';

  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, zoomPlugin)



  export default {
    name: 'ComponentTest',
    // components: { Bar },
    props: {
      plugins: {
      type: Array,
      default: () => []
      }
    },

    methods: {
    },  // -----------  methods 
    data() {
      // console.log(this)
      // console.log(this.$store)
      // console.log(this.$data)


      return {
        options: {
          plugins: {
            title: {
              display: true,
              text: 'Chart.js Bar Chart - Stacked'
            },
          },
          responsive: true,
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true
            }
          }
        },
        chartData: {
          labels: ['농장평균배출량', '내농장배출량', '저탄소농장평균배출량'],
          datasets: [
            {
              label: '장내발효',
              backgroundColor: '#D2E4D6',
              data: [100, 70, 50]
            },
            {
              label: '분뇨처리',
              backgroundColor: '#90B499',
              data: [100, 70, 50]
            },
            {
              label: '에너지',
              backgroundColor: '#C6E4F5',
              data: [100, 70, 50]
            },
            {
              label: '그외',
              backgroundColor: '#82B2CA',
              data: [50, 30, 20]
            }
          ],
        }

        // chartData: {
        //   labels: [
        //   'January',
        //   'February',
        //   'March',
        //   'April',
        //   'May',
        //   'June',
        //   'July',
        //   'August',
        //   'September',
        //   'October',
        //   'November',
        //   'December'
        // ],
        // datasets: [
        //   {
        //     label: 'Data One',
        //     backgroundColor: '#f87979',
        //     data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
        //   }
        // ]
        // },

        // chartOptions: {
        //   responsive: true,
        //   indexAxis: 'y',
        //   plugins: {
        //     zoom: {
        //       zoom: {
        //         wheel: {
        //           enabled: true,
        //         },
        //         pinch: {
        //           enabled: true
        //         },
        //         mode: 'xy',
        //       }
        //     }
        //   }
        // },
      }
    },

  }
</script>

<style scoped  lang="scss">
       .container_2 {
            display: grid;
            grid-template-columns: repeat(3, 1fr); /* 3 columns */
            grid-template-rows: repeat(2, auto); /* 2 rows */
            gap: 10px; /* Adjust spacing between boxes as needed */
            max-width: 300px; /* Adjust container width as needed */
            margin: 0 auto;
        }
        .container div {
            background: green;
            border: 2px solid white;
            height: 50px; /* Adjust height as needed */
        }
        .box1 {
            grid-column: span 2; /* Span across 2 columns */
            grid-row: 1; /* First row */
        }
        .box2 {
            grid-column: span 1; /* Span across 1 column */
            grid-row: 1; /* First row */
        }
        .box3 {
            grid-column: span 1; /* Span across 1 column */
            grid-row: 2; /* Second row */
        }
        .box4 {
            grid-column: span 1; /* Span across 1 column */
            grid-row: 2; /* Second row */
        }
        .box5 {
            grid-column: span 1; /* Span across 1 column */
            grid-row: 2; /* Second row */
        }
</style>
